import { padStart } from '@/utils/index'

const handleInputs = (params) => {
    return params
        .filter(({ start, end, val }) => start && end && val)
        .reduce((prev, item) => {
            const { start, end, val }  = item
            if (start === end) {
                prev[start] = val
            } else {
                const start_date = new Date(start)
                const end_time = new Date(end).getTime()
                while (start_date.getTime() <= end_time) {
                    const month = (start_date.getMonth() + 1)
                    const start_str = start_date.getFullYear() + '-' + padStart(month)
                    prev[start_str] = val
                    start_date.setMonth(start_date.getMonth() + 1)
                }
            }
            return prev
        }, {})
}

const getLoanRate = () => {
    return 0.9
}

const getLoanYears = (user, couple) => {
    const MAX_AGE = {
        '男': 65,
        '女': 60
    }
    const user_year = MAX_AGE[user.gender] - user.age
    const couple_year = couple.gender ? MAX_AGE[couple.gender] - couple.age : 0
    return Math.min(Math.max(user_year, couple_year), 30)
}

const getUserLoan = (parmas) => {
    const { in_records, out_records = [] } = parmas
    const rate = getLoanRate()
    const income = handleInputs(in_records)
    const expense = handleInputs(out_records)
    let loan = 0
    const getTime = (date) => new Date(date).getTime()
    const income_month_arr = Object.keys(income).map(getTime)
    const expense_month_arr = Object.keys(expense).map(getTime)
    const all_month = expense_month_arr.concat(income_month_arr)
    const start_date_time = Math.min.apply(Math, income_month_arr)
    const end_date_time = Math.max.apply(Math, all_month)
    const end_date = new Date(end_date_time)
    let discount = 0
    let count = 1
    while (end_date.getTime() >= start_date_time) {
        const month = end_date.getMonth()
        const time = end_date.getFullYear() + '-' + padStart(month + 1)
        const in_item = Number(income[time] || 0)
        const out_item = Number(expense[time] || 0)
        const diff_in = in_item - out_item + discount
        if (diff_in >= 0) {
            loan += diff_in * count * rate
            discount = 0
        } else {
            discount = diff_in
        }
        if (count != 1 || in_item) {
            count++
        }
        end_date.setMonth(month - 1)
    }
    loan += discount
    return parseInt(loan)
}

const checkContinousIn = (params) => {
    return params.every(({ in_records }) => {
        const income = handleInputs(in_records)
        const last_in = in_records[0]
        const { end } = last_in
        for (let i = 0; i < 6; i++) {
            const end_date = new Date(end)
            end_date.setMonth(end_date.getMonth() - i)
            const time = end_date.getFullYear() + '-' + padStart(end_date.getMonth() + 1)
            if (!income[time]) {
                return false
            }
        }
        return true
    })
}

const GENDER_AGE = {
    '男': 60,
    '女': 55
}
const checkMinAge = (user) => {
    return user.age >= 18
}
const getMinAgeErr = (age) => {
    return `申请贷款需年满18周岁`
}
const checkMaxAge = (user) => {
    return GENDER_AGE[user.gender] > user.age
}

const getMaxAgeErr = (gender, is_couple) => {
    return `${gender}性贷款年龄不能超过${GENDER_AGE[gender]}，您${is_couple ? '配偶' : ''}的年龄已经超出`
}

export const compute = (params) => {
    const [user_params, couple_params] = params
    const { user } = user_params
    if (!checkMinAge(user)) {
        return {
            err: getMinAgeErr()
        }
    }
    if (!checkMaxAge(user)) {
        return {
            err: getMaxAgeErr(user.gender)
        }
    }
    if (!checkContinousIn(params)) {
        return {
            err: params.length === 1 ?
                '申请公积金贷款需连续缴存6个月及以上，您最近连续缴存记录不足6个月。'
                :
                '夫妻共同申请公积金贷款需双房都连续缴存6个月及以上，您或者您配偶最近连续缴存记录不足6个月。'
        }
    }
    let max_loan = 400000
    const user_loan = getUserLoan(user_params)
    let couple_loan = 0
    let couple = {}
    if (couple_params) {
        couple = couple_params.user
        if (!checkMinAge(couple)) {
            return {
                err: getMinAgeErr()
            }
        }
        if (!checkMaxAge(couple)) {
            return {
                err: getMaxAgeErr(couple.gender, true)
            }
        }
        max_loan = 700000
        couple_loan = getUserLoan(couple_params)
    }
    const loan = (
        Math.round(
            Math.max(0, Math.min(max_loan, user_loan + couple_loan) ) / 1000) / 10
        ).toFixed(1)
    return {
        err: '',
        res: {
            years: getLoanYears(user, couple),
            loan
        }
    }
}

let result = {}

export const getResult = () => result

export const setResult = (val) => result = val